import React, { useEffect, useState } from "react";
import AOS from "aos";
import $ from "jquery";
import "aos/dist/aos.css";

// Layout components
import Header from "../../widgets/Header";
import Footer from "../../widgets/Footer";

// Page sections
import Banner from "./Banner";
import Video from "./Video";
import About from "./About";
import YourHealth from "./YourHealth";
import Productivity from "./Productivity";
import Blueprint from "./Blueprint";
import Rating from "./Rating";
import HowWorks from "./HowWorks";
import HowWorkss from "./HowWorkss";
import Client from "./Client";
import YourDna from "./YourDna";
import DecodeDna from "./DecodeDna";
import Symptoms from "./Symptoms";
import Plan from "./Plan";
import Trigr from "./Trigr";
import Tracking from "./Tracking";
import Experts from "./Experts";
import Faq from "./Faq";
import Ready from "./Ready";

import APlan from "./APlan";

// ScrollStack
import ScrollStack, { ScrollStackItem } from "./ScrollCards";

const scrollCards = [
  { title: "Card 1", text: "This is the first card in the stack" },
  { title: "Card 2", text: "This is the second card in the stack" },
  { title: "Card 3", text: "This is the third card in the stack" },
];

export default function Home() {
  const [canProceed, setCanProceed] = useState(false);
  const scrollThreshold = 4700; // px
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 400,
      easing: "ease-in-sine",
      delay: 100,
    });
  }, []);


  useEffect(() => {
    const isMobile = window.innerWidth;
    //  console.log("indx mobile ",isMobile);
    const handleScroll = () => {
      // console.log(window.scrollY, " scroll");
      if (window.scrollY >= scrollThreshold) {
        setCanProceed(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);



  return (
    <>
      <Header />

      {/* Main sections */}
      <Banner />
      <Video />
      <About />
      <YourHealth />
      <Productivity />
      <Blueprint />
      <Rating />
      <HowWorkss />
      {/* <HowWorks /> */}

      <Client />
      <YourDna />
      {/* <DecodeDna /> */}
      <Symptoms />
      <APlan />
      {/* <Plan /> */}
      <Trigr />
      <Tracking />
      <Experts />
      <Faq />

      {/* ScrollStack section */}
      {/* <ScrollStack  itemDistance={80} itemStackDistance={50} blurAmount={2}>
        {scrollCards.map((card, index) => (
          <ScrollStackItem key={index}>
            <h2>{card.title}</h2>
            <p>{card.text}</p>
          </ScrollStackItem>
        ))}
      </ScrollStack> */}

      {/* Call to action / footer */}
      <Ready />
      <Footer />


    </>
  );
}
